import React from "react";
import nutritionImage from "../assets/images/margarita-zueva-aDxzwSmY90A-unsplash.jpg";
import ContactUs from "./organisms/ContactUs";
import HeadingText from "./atoms/HeadingText";
import ContentText from "./atoms/ContentText";
import ParaText from "./atoms/ParaText";
import useTranslate from "../hooks/useTranslate";

function CorporateNutrition() {
  const heading = useTranslate(
    "workwithMnPage.corporateNutrition.section.heading"
  );
  const subheading = useTranslate(
    "workwithMnPage.corporateNutrition.section.subheading"
  );
  const contentText = useTranslate(
    "workwithMnPage.corporateNutrition.section.contentText"
  );

  const listItems = useTranslate(
    "workwithMnPage.corporateNutrition.section.listItems"
  );
  const paraText1 = useTranslate(
    "workwithMnPage.corporateNutrition.section.contentText4"
  );

  return (
    <>
      <section className="bg-white py-12">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row">
          <div className="basis-1/2">
            <HeadingText variant="h2">{heading}</HeadingText>
            <HeadingText variant="h3">{subheading}</HeadingText>
            <ContentText>{contentText}</ContentText>
            <ParaText>
              <ul className="list-disc list-inside mt-4">
                {listItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </ParaText>
            <ParaText>{paraText1}</ParaText>
          </div>
          <div className="basis-1/2">
            <img
              src={nutritionImage}
              alt="Nutrition"
              className="md:max-w-[90%] max-w-[100%] ml-auto"
            />
          </div>
        </div>
      </section>
      <ContactUs />
    </>
  );
}

export default CorporateNutrition;
